import dayjs from "dayjs";
import { valorDoModo } from "../general/homeV2Helpers";

export const somenteData = (valor) =>
  valor ? String(valor).slice(0, 10) : null;

export const diaSeguinte = (valor) => {
  const data = somenteData(valor);
  if (!data) return null;
  const [ano, mes, dia] = data.split("-").map(Number);
  const proximo = new Date(Date.UTC(ano, mes - 1, dia + 1));
  return proximo.toISOString().slice(0, 10);
};

export const parametrosDaComparacao = ({
  branchIds,
  categorySource,
  categoriaId,
  startDate,
  endDate,
  revenueMode = "presencial",
}) => {
  const base = {
    branch_id: branchIds,
    start: somenteData(startDate),
    end: diaSeguinte(endDate),
    tipo: revenueMode,
    category_source: categorySource,
  };
  if (categorySource === "ouran") {
    return { ...base, category_id: categoriaId };
  }
  return { ...base, collection_legacy_id: categoriaId };
};

const MOTIVOS = {
  erp: "usa as categorias do sistema da loja",
  ouran: "usa o catálogo Ouran",
  misto: "mudou de classificação dentro do período",
  timeline: "está com a linha do tempo de categorias inconsistente",
};

export const textoDasLojasFora = (meta) => {
  const fora = meta?.fora_por_modo || [];
  if (!fora.length) return null;
  const itens = fora.map(
    (loja) => `${loja.nome} (${MOTIVOS[loja.motivo] || loja.motivo})`
  );
  const plural = fora.length > 1;
  return `${plural ? "Lojas" : "Loja"} fora da comparação por estarem em outro modo de categoria: ${itens.join("; ")}. A comparação só cruza lojas no mesmo modo durante todo o período.`;
};

export const opcoesDeCategoria = ({
  modoOuran,
  opcoesDoModo,
  colecoesGerais,
}) => {
  if (modoOuran) {
    return (opcoesDoModo || []).filter((opcao) => opcao.value !== "all");
  }
  return (colecoesGerais || []).map((c) => ({
    value: c.legacy_id,
    label: c.description,
  }));
};

export const CHAVES_DERIVADAS = [
  "faturamento_por_m2",
  "permanencia_media",
  "faturamento_por_tempo_permanencia",
];

const numeroOuNulo = (valor) =>
  valor === null || valor === undefined ? null : Number(valor);

const metricasDerivadas = (item) => ({
  faturamento_por_m2: numeroOuNulo(item?.faturamento_por_m2_mes),
  permanencia_media: numeroOuNulo(item?.atencao_media_por_visitante),
  faturamento_por_tempo_permanencia: numeroOuNulo(
    item?.faturamento_por_pessoa_minuto
  ),
});

export const periodoDerivado = (startDate, endDate) =>
  startDate && endDate
    ? {
        start: startDate.slice(0, 10),
        end: dayjs(endDate.slice(0, 10)).add(1, "day").format("YYYY-MM-DD"),
      }
    : { start: null, end: null };

export const derivadasDoPeriodo = (resposta) => {
  const filial = resposta?.branches?.[0];
  return filial ? metricasDerivadas(filial) : null;
};

export const serieDiariaDerivada = (resposta) => {
  const buckets = resposta?.branches?.[0]?.buckets;
  if (!buckets) return null;
  const serie = { dates: buckets.map((bucket) => bucket.key) };
  CHAVES_DERIVADAS.forEach((chave) => {
    serie[chave] = buckets.map((bucket) => metricasDerivadas(bucket)[chave]);
  });
  return serie;
};

const diasDoPeriodo = (start, end) => {
  const dias = [];
  for (
    let dia = dayjs(start);
    dia.isBefore(dayjs(end));
    dia = dia.add(1, "day")
  ) {
    dias.push(dia.format("YYYY-MM-DD"));
  }
  return dias;
};

const porChave = (itens) =>
  Object.fromEntries((itens || []).map((item) => [item.key, item]));

export const vendasDoPeriodo = (revenue, conversion, revenueMode) => {
  if (!revenue || !conversion) return null;
  const filial = conversion.branches?.[0];
  return {
    faturamento_total: valorDoModo(revenue.totals, revenueMode),
    ticket_medio: numeroOuNulo(revenue.totals?.ticket_medio),
    oportunidades: Number(filial?.oportunidades || 0),
    conversao: numeroOuNulo(filial?.conversao_pct),
  };
};

export const serieDiariaDeVendas = ({
  revenue,
  conversion,
  revenueMode,
  start,
  end,
}) => {
  if (!revenue || !conversion || !start || !end) return null;
  const vendas = porChave(revenue.groups);
  const entradas = porChave(conversion.branches?.[0]?.buckets);
  const dates = diasDoPeriodo(start, end);
  return {
    dates,
    faturamento_total: dates.map(
      (dia) => valorDoModo(vendas[dia], revenueMode) ?? 0
    ),
    ticket_medio: dates.map((dia) => numeroOuNulo(vendas[dia]?.ticket_medio)),
    oportunidades: dates.map((dia) =>
      Number(entradas[dia]?.oportunidades || 0)
    ),
    conversao: dates.map((dia) => numeroOuNulo(entradas[dia]?.conversao_pct)),
  };
};

export const metaDoPeriodo = (goals) => {
  const filial = goals?.branches?.[0];
  if (!filial) return null;
  return {
    meta_atingido: filial.has_goals
      ? numeroOuNulo(filial.percent_meta_periodo)
      : null,
  };
};
